<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="d-flex justify-content-end mb-2">
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copyToClipboard()">
      <i class="fa fa-copy" aria-hidden="true"></i> Copy to Clipboard
    </button>
  </div>
  <pre class="json-display" [innerHTML]="syntaxHighlightedJson"></pre>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Close</button>
</div>

<style>
  .json-display {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 15px;
    max-height: 500px;
    overflow: auto;
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  ::ng-deep .json-display .json-key {
    color: #881391;
    font-weight: bold;
  }

  ::ng-deep .json-display .json-string {
    color: #0b7500;
  }

  ::ng-deep .json-display .json-number {
    color: #1750eb;
  }

  ::ng-deep .json-display .json-boolean {
    color: #0000ff;
  }

  ::ng-deep .json-display .json-null {
    color: #808080;
  }
</style>
